(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(59622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_models_cms_page_CmsPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26308);
/* harmony import */ var _components_elements_seo_SeoHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32192);



var Homepage = function(param) {
    var cmsPage = param.cmsPage, cmsConfig = param.cmsConfig, travelTypes = param.travelTypes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_seo_SeoHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seoSettings: cmsPage.seoSettings,
                noIndex: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_models_cms_page_CmsPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                cmsPage: cmsPage,
                cmsConfig: cmsConfig,
                travelTypes: travelTypes
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Homepage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [789,7478,2367,1664,2247,8037,5583,562,2912,651,7740,3079,6466,2298,9487,115,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);